import { GeometryChangeRetriever } from "./geometryChangeRetriever";
import { ChangeTypes, GeometryChange } from "./types";
import { Feature, LineString } from "geojson";
import { GeometryType } from "../../../core/geo/types";
import Logger from "../../../common/util/Logger";
import { getSegmentChanges } from "./segments/segmentChangeRetriever";
const logger = new Logger("lineChangeRetriever");

const handleCorridorWidthChanged = (
    featureBefore: Feature<LineString> | undefined,
    featureNow: Feature<LineString>
): GeometryChange[] => {
    const width = featureNow!.properties!.corridor.width;
    logger.info(`GeometryChange: corridor width changed to : ${width}`);
    return [
        {
            type: ChangeTypes.CORRIDOR_WIDTH_CHANGED,
            width: width,
        },
    ];
};

const corridorWidthChange = (
    featureBefore: Feature<LineString>,
    featureNow: Feature<LineString>,
    geometryType: GeometryType
) => {
    return (
        geometryType === GeometryType.LINE_STRING &&
        featureBefore?.properties?.corridor?.width !== featureNow.properties?.corridor?.width
    );
};

export const lineChangeRetriever: GeometryChangeRetriever = {
    retrieveChange(featureBefore, featureNow): GeometryChange[] {
        const lineBefore = featureBefore as Feature<LineString>;
        const lineNow = featureNow as Feature<LineString>;
        const geometryType = featureNow.geometry.type as GeometryType;
        if (featureBefore && corridorWidthChange(lineBefore, lineNow, geometryType)) {
            return handleCorridorWidthChanged(lineBefore, lineNow);
        }
        return getSegmentChanges(lineBefore, lineNow);
    },
};
